import CreateOrder from "../components/CreateOrder";
import UpdateOrder from "../components/UpdateOerder";
import InfoOrder from "../components/InfoOrder";
import AssignOrder from "../components/AssignOrder";
import AssignIntegra from "../components/AssignIntegra";
import ChangeStatus from "../components/ChangeStatus";
import TrafficRules from "../components/trafficRules";
import {OrderQueryType} from "./query";

export const MODALS = [
  { key: "isRight", Component: CreateOrder },
  { key: "isUpdate", Component: UpdateOrder },
  { key: "isInfoOrder", Component: InfoOrder },
  { key: "isAssignOrder", Component: AssignOrder },
  { key: "isAssignIntegra", Component: AssignIntegra },
  { key: "isChangeStatus", Component: ChangeStatus },
  { key: "isTrafficRules", Component: TrafficRules },
];

export interface ModalState {
  isRight: boolean;
  isUpdate: boolean;
  isInfoOrder: boolean;
  isAssignOrder: boolean;
  isAssignIntegra: boolean;
  isChangeStatus: boolean;
  isTrafficRules: boolean;
  selectedOrderId: string | null;
  selectedDate: string | null;
  tabId: string | null;
}

export const modalKeys: Array<keyof ModalState> = [
  "isRight",
  "isUpdate",
  "isInfoOrder",
  "isAssignOrder",
  "isAssignIntegra",
  "isChangeStatus",
  "isTrafficRules",
];

export const INITIAL_MODAL_STATE: ModalState = {
  isRight: false,
  isUpdate: false,
  isInfoOrder: false,
  isAssignOrder: false,
  isAssignIntegra: false,
  isChangeStatus: false,
  isTrafficRules: false,
  selectedOrderId: null,
  selectedDate: null,
  tabId: ""
};

export type OrderActionKey =
    | "toggleAssignOrder"
    | "toggleAssignIntegra"
    | "toggleInfoOrder"
    | "toggleUpdate"
    | "toggleChangeStatus";

export const ENABLED_ACTIONS_BY_TYPE: Record<OrderQueryType, OrderActionKey[]> = {
  active: ["toggleAssignOrder", "toggleAssignIntegra", "toggleInfoOrder", "toggleUpdate", "toggleChangeStatus"],
  waiting: ["toggleAssignOrder", "toggleAssignIntegra", "toggleInfoOrder", "toggleUpdate"],
  notActive: ["toggleInfoOrder", "toggleUpdate"],
};